import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import RouterDOM from './Router';
import usePageViews from './hooks/usePageViews';

const App = () => {
  usePageViews(); // Called inside Router context now
  return <RouterDOM />;
};

const container = document.getElementById('root');
if (!container) throw new Error('Root container not found');

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
